import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  // TODO: refactor naar Repeater class?

  $('body').on('bless', function(e) {
    const $target = $(e.target)
    const $repeaterInputs = $target.is('[data-repeater]')
      ? $target
      : $target.find('[data-repeater]')
    debugLogScriptName($repeaterInputs, 'repeater.js') // DEBUG
    $repeaterInputs.each(function() {
      let $input = $(this)
      $input = $input.wrap('<div class="repeater-element"></div>')
      addRepeaterButtons($input)
    })
  })

  function createRepeaterElement($input) {
    var $clonedInput = $input
        .clone(false, false)
        .prop('required', false)
        .val('')
        .wrap('<div class="repeater-element"></div>'),
      $repeaterElement = addRepeaterButtons($clonedInput)
    $input
      .closest('.form-group')
      .find('.repeater-element .button--repeater')
      .hide()
    $repeaterElement.insertAfter($input.parents('.repeater-element'))
    $clonedInput.focus()
  }

  function removeRepeaterElement($input) {
    var $parent = $input.parents('.repeater-element')
    $parent
      .prev('.repeater-element')
      .find('.button--repeater')
      .show()
      .end()
      .find('[data-repeater]')
      .focus()
    $parent.remove()
  }

  function addRepeaterButtons($input) {
    var $repeaterElement = $input.parents('.repeater-element'),
      $addButton = createRepeaterButton('add', $input),
      $removeButton = createRepeaterButton('remove', $input)
    if ($input.prop('required')) {
      $repeaterElement.append($addButton)
    } else {
      $repeaterElement.append($removeButton).append($addButton)
    }
    return $repeaterElement
  }

  function createRepeaterButton(action, $input) {
    return $('<button>', {
      class: 'button button--repeater ' + 'button--repeater-' + action,
      type: 'button',
      on: {
        click: function(e) {
          if (action == 'add') {
            createRepeaterElement($input)
          }
          if (action == 'remove') {
            removeRepeaterElement($input)
          }
        },
      },
    })
  }
})
